module.exports = __webpack_public_path__ + "img/logoLight.f19ae987.svg";